import * as yup from 'yup';

export const validateAboutYouForm = yup.object({
  firstName: yup.string().required('First name is a required field'),
  lastName: yup.string().required('Last name is a required field'),
  gender: yup.string().required('Gender is a required field'),
  dob: yup.string().required('Date of birth is a required field')
});

export const validateStoryForm = yup.object({
  story: yup
    .string()
    .required('Story is a required field')
    .max(3900, 'Cannot exceed 3900 characters')
});
const USZipCodesRegExp = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
export const validateAddressForm = yup.object({
  addressline1: yup.string().max(150, 'Cannot exceed 150 characters'),
  addressline2: yup.string().max(150, 'Cannot exceed 150 characters'),
  city: yup.string().max(30, 'Cannot exceed 30 characters'),
  state: yup.string(),
  province: yup.string().max(20, 'Cannot exceed 20 characters'),
  country: yup.string(),
  zip: yup
    .string()
    .when('country', {
      is: 'United States',
      then: yup.string().matches(USZipCodesRegExp, 'US Zip Code is not valid')
    })
    .max(20, 'Cannot exceed 20 digits'),
  secondaryAddressline1: yup.string().max(80, 'Cannot exceed 80 characters'),
  secondaryAddressline2: yup.string().max(80, 'Cannot exceed 80 characters'),
  secondaryCity: yup.string().max(30, 'Cannot exceed 30 characters'),
  secondaryState: yup.string(),
  secondaryProvince: yup.string().max(20, 'Cannot exceed 20 characters'),
  secondaryCountry: yup.string(),
  secondaryZip: yup
    .string()
    .when('secondaryCountry', {
      is: 'United States',
      then: yup.string().matches(USZipCodesRegExp, 'US Zip Code is not valid')
    })
    .max(20, 'Cannot exceed 20 digits')
});

// const phoneRegExp = /^\+?[1-9]\d{1,14}$/;
export const validateEmailPhoneForm = yup.object({
  email: yup.string().email('Email must be a valid email').required('Email is a required field'),
  email2: yup.string().email('Email must be a valid email'),
  phone: yup.string(),
  phone2: yup.string(),
  phone3: yup.string(),
  phone4: yup.string()
});

export const validateLanguageForm = yup.object({
  languages: yup.array().when('needInterpreter', {
    is: 'Y',
    then: yup
      .array()
      .required(
        'Language field must have at least 1 items when Require an interpreter below is checked'
      )
  })
});
export const validateCardiologistForm = yup.object({
  cardiologist: yup.string(),
  cardiologistphone: yup.string(),
  cardiologistemail: yup.string().trim().email('Email must be a valid email')
  // cardiologistletter: yup.boolean()
});
export const validatePCPForm = yup.object({
  pcp: yup.string(),
  pcpphone: yup.string(),
  pcpemail: yup.string().trim().email('Email must be a valid email')
  // pcpletter: yup.boolean()
});
export const validateOBGYNForm = yup.object({
  obgyn: yup.string(),
  obgynphone: yup.string(),
  obgynemail: yup.string().trim().email('Email must be a valid email')
  // obgynletter: yup.boolean()
});
export const validateReferringMDInfoForm = yup.object({
  cardiologist: yup.string(),
  cardiologistphone: yup.string(),
  cardiologistemail: yup.string().trim().email('Email must be a valid email'),
  cardiologistletter: yup.boolean(),
  pcp: yup.string(),
  pcpphone: yup.string(),
  pcpemail: yup.string().trim().email('Email must be a valid email'),
  pcpletter: yup.boolean(),
  obgyn: yup.string(),
  obgynphone: yup.string(),
  obgynemail: yup.string().trim().email('Email must be a valid email')
  //obgynletter: yup.boolean(),
});

export const validateBCHMDInfoForm = yup.object({
  program: yup.string(),
  preferredSurgeonName: yup.string(),
  preferredCardiologistName: yup.string()
});

export const validateOtherInfoForm = yup.object({
  whyChoose: yup.string(),
  hospitalName: yup.string()
});
